// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2dRfw","rootCenter":"LoadMoreObserver_rootCenter__1ezDs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__f6dIz"};